import { UITheme } from './UITheme';
import * as Phaser from 'phaser';
import { LocalizationManager } from '../managers/LocalizationManager';

export function createTelegramLink(scene: Phaser.Scene): Phaser.GameObjects.Text {
    const link = scene.add.text(0, 0, LocalizationManager.getInstance().getText('ui.telegram_news'), {
        fontFamily: UITheme.body,
        fontSize: '16px',
        color: UITheme.text,
        align: 'center',
        padding: { x: 8, y: 12 }
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    link.on('pointerover', () => link.setStyle({ color: '#ffffff' }));
    link.on('pointerout', () => link.setStyle({ color: UITheme.text }));
    link.on('pointerup', (_pointer: Phaser.Input.Pointer, _x: number, _y: number, event: Phaser.Types.Input.EventData) => {
        event.stopPropagation();
        window.open('https://t.me/+zDjN3qxWP6EyY2Q6', '_blank', 'noopener,noreferrer');
    });

    return link;
}
